import React from 'react';
import { Container, Nav, Navbar,  } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <div  className="bg-dark" style={{backgroundColor:'', }}>
             <Navbar className="container fw-bold text-white sticky-top " sti  bg="" expand="lg">
        <Container fluid>
          <Navbar.Brand href="#"></Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-2  my-lg-0"
              style={{ maxHeight: '100px',textDecoration: 'none' }}
              navbarScroll
            >
              <Nav.Link style={{textDecoration: 'none',}} className="ms-5 my-2 text-white" href="#projects">Projects</Nav.Link>
              <Nav.Link style={{textDecoration: 'none',}} className="ms-5 my-2 text-white" href="#home">Home  </Nav.Link>
              <Nav.Link style={{textDecoration: 'none',}} className="ms-5 my-2 text-white" href="#about">About Us</Nav.Link>
              <Link style={{textDecoration: 'none',}} className="ms-5 my-3 text-white" to="/blogs">Blogs</Link>
              <Nav.Link  style={{textDecoration: 'none',}} className="ms-5 my-2 text-white" href="#contuct">Contact Me</Nav.Link>
           
              <Nav.Link style={{marginRight:'150px'}} className="ms-5 text-white" href="#action2"> </Nav.Link>
              
              <Nav.Link className=" ms-3 text-white" target="_blank" href="https://github.com/RonyMiah"><i className="fab fs-4  py-2 fa-github"></i></Nav.Link>
              
              <Nav.Link className=" ms-3 text-white" target="_blank" href="https://www.linkedin.com/in/ronymiah/"><i className="fab  py-2 fs-4 fa-linkedin"></i></Nav.Link>
              <Nav.Link className="ms-3 text-white" target="_blank" href="https://www.youtube.com/channel/UCJJnoGXaRAFH8RvoPCHBUSQ"><i class="fab  py-2 fs-4 fa-youtube"></i></Nav.Link>
              <Nav.Link className="ms-3 text-white" target="_blank" href="https://web.facebook.com/khairojJaman/"><i class="fab fs-4 py-2 fa-facebook-square"></i></Nav.Link>
              
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
       </div>
    );
};

export default Header;